// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1njmB","delete":"styles_delete__2bR0I","update":"styles_update__2Bjpj","add":"styles_add__Rc7tm"};